import { DataDropdown } from "capitalrx-components-2.0/lib/forms";
import { useRemoteTableDataSource } from "capitalrx-components-2.0/lib/general";

import { getApiBaseUrl } from "@/api";
import { FormElementBaseProps } from "@/api/interfaces";
import { useCallback } from "react";

interface MDDBDrug {
  ndc?: string | null;
  drug_name?: string | null;
  gpi?: string | null;
  dosage?: string | null;
  dosage_form?: string | null;
  package_size?: string | null;
  package_size_unit_of_measure?: string | null;
}

export const NDCDropdown = ({
  name = "ndc",
  label = "Drug",
  required = false,
  disabled = false,
  testId,
}: FormElementBaseProps) => {
  const apiBaseUrl = getApiBaseUrl();

  const maxLength = 100;
  const ndcLabelProvider = useCallback((row: MDDBDrug) => {
    const drugName = row?.drug_name ?? "";
    const ndc = row?.ndc ?? "";
    const truncatedName =
      drugName.length > maxLength ? drugName.slice(0, maxLength) + "..." : drugName;
    return `${ndc} - ${truncatedName}`;
  }, []);


  const dataSource = useRemoteTableDataSource<MDDBDrug>(
    `${apiBaseUrl}/mddb_drug/list`,
    (row: MDDBDrug) => row?.ndc ?? "",
    {
      pageSize: 15,
      idFilterName: "drug_name_or_ndc",
      authTokenRequired: false,
    },
  );
  return (
    <DataDropdown.Field
      dataSource={dataSource}
      optionLabelProvider={ndcLabelProvider}
      label={label}
      name={name}
      placeholder="Select one or type an NDC"
      searchField="drug_name_or_ndc"
      required={required}
      disabled={disabled}
      testId={testId}
    />
  );
};
